import { type QueryKey } from '@/feature/product-list/services/productList.types'

export const getProductClickContext = (queryKey: QueryKey, isFiltered: boolean, value: string) => {
  if (queryKey === 'categories') {
    return `liste ${isFiltered ? 'filtrée' : 'non-filtrée'} | ${value}`
  } else if (queryKey === 'searchList') {
    return `résultat de recherche ${isFiltered ? 'filtré' : 'non-filtré'} | ${value}`
  } else if (queryKey === 'brand') {
    return value
  } else if (queryKey === 'event') {
    return `liste animation | ${value}`
  }

  return ''
}
